import { type Rule } from "antd/lib/form"
import i18n from "Shared/locales/i18n"

export const createChangeHistoryRules = () => ({
    resource: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
    changeHistoryPeriod: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
})
